<template>
    <div class="flex relative my-auto container mx-auto">

      <PrevArrow prev="sub-offer-one"/>

      <div class="subsection-big-circle bg-black rounded-full mx-auto">
        <h1 class="deep-info-sub-heading text-white mx-auto pt-20 text-2xl font-bold">PROFITABILITY</h1>
        <p class="text-teal mt-8 text-4xl font-bold leading-tight">INCREASE IN <br>ADVERTISING <br>REVENUE</p>
      </div>

      <NextArrow next="sub-offer-three"/>

    </div>
</template>

<script>
import PrevArrow from "@/components/deepinfo/subnavigation/PrevArrow.vue";
import NextArrow from "@/components/deepinfo/subnavigation/NextArrow.vue";

export default {
  name: "OfferSubTwo",
  components:{
    PrevArrow,
    NextArrow
  }
}
</script>
